import { logger } from '@/lib/api/logger';

import { oddsLib } from './oddslib';

const oddsFormatCheckList = ['indonesian', 'american'];

export const oddsConverter = (odd, format) => {
  const convertable = oddsLib.from('decimal', odd);
  let res = '';

  switch (format) {
    case 'decimal':
      res = Number(odd).toFixed(2);
      break;
    case 'american':
      res = convertable.to(format, { precision: 0 });
      break;
    case 'fractional':
      res = convertable.to(format);
      break;
    case 'hongKong':
      res = convertable.to(format, { precision: 2 });
      break;
    case 'malaysian':
      res = convertable.to(format, { precision: 2 });
      break;
    case 'indonesian':
      res = convertable.to(format, { precision: 2 });
      break;
    default:
      logger.warn(`Unknown odd format (${format}) in odds converter`);
      break;
  }
  const isEmptyVal = !Number.isFinite(res) && oddsFormatCheckList.includes(format);

  if (!isEmptyVal && format === 'american') {
    res = Number(res) > 0 ? `+${res}` : `${res}`;
  }
  return isEmptyVal ? '' : res;
};
